import React from 'react';
import { withTranslation } from "react-i18next";
import CaAccountModalView from "./CaAccountModalView";
import { VIEW_CREATE_ACCOUNT, VIEW_FORGOT_PASSWORD } from "../../constants/accountModalConstants";

const CaAccountLoginContainer = props => {

    const { onNavigate } = props;

    const newProps = Object.assign({},{
        onSubNavClick:()=>onNavigate(VIEW_CREATE_ACCOUNT),
        forgotPasswordNav:()=>onNavigate(VIEW_FORGOT_PASSWORD),
        formFieldsData: 
            [
                {
                    type:'email',
                    validateAs:'email',
                    placeholder:props.t('account_modal.placeholders.email'),
                    id:"login_email"
                },
                {
                    type:'password',
                    validateAs:'password',
                    placeholder: props.t('account_modal.placeholders.password'),
                    id:"login_password"
                }
            ],
            "title": props.t('account_modal.login.title'),
            "submitCta": props.t('account_modal.login.submitCta'),
            "subNavText": props.t('account_modal.login.subNavText'),
            "subNavCta": props.t('account_modal.login.subNavCta'),
            "forgotPasswordText": props.t('account_modal.login.forgotPasswordText'),
        });

    return (
        <CaAccountModalView
            {...Object.assign({},props,newProps)}
        />
    )
}
export default withTranslation("translations")(CaAccountLoginContainer);
